import { createFileRoute } from '@tanstack/react-router';
import ResourceAdmin from 'containers/ResourceAdmin';

export const Route = createFileRoute('/_authenticated/resourceAdmin')({
  component: ResourceAdmin,
});
